import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b494c8d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Estadísticas")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Listado")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Utilidades")

import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { IonTabBar, IonTabButton, IonTabs, IonLabel, IonPage, IonRouterOutlet } from '@ionic/vue'

import IonicIcon from '@/components/IonicIcon.vue'
import NewRefundButton from '@/components/Refunds/NewRefundButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'TabsView',
  setup(__props) {

const route = useRoute()

const isNewRefundButtonVisible = computed(() => {
  const blacklistedRoutes = ['incidents', 'incidents-detail', 'incidents-new']

  return !blacklistedRoutes.includes(route.name as string)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonTabs), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonRouterOutlet)),
          (_unref(isNewRefundButtonVisible))
            ? (_openBlock(), _createBlock(NewRefundButton, { key: 0 }))
            : _createCommentVNode("", true),
          _createVNode(_unref(IonTabBar), {
            color: "primary",
            slot: "bottom"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonTabButton), {
                tab: "tab1",
                href: "/tabs/statistics"
              }, {
                default: _withCtx(() => [
                  _createVNode(IonicIcon, {
                    color: "",
                    icon: "barChartOutline"
                  }),
                  _createVNode(_unref(IonLabel), null, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTabButton), {
                tab: "tab2",
                href: "/tabs/refunds/remote"
              }, {
                default: _withCtx(() => [
                  _createVNode(IonicIcon, {
                    color: "",
                    icon: "listOutline"
                  }),
                  _createVNode(_unref(IonLabel), null, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTabButton), {
                tab: "tab3",
                href: "/tabs/utils"
              }, {
                default: _withCtx(() => [
                  _createVNode(IonicIcon, {
                    color: "",
                    icon: "settingsOutline"
                  }),
                  _createVNode(_unref(IonLabel), null, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})